<template>
    <div class="scenario-view-root do-not-select" ref="scenarioRootRef">
        <div class="scenario-view-wrapper do-not-select" :class="scenarioClasses"
             @touchmove="mouseMoveScenario"
             @wheel="wheelScroll"
             @mouseup="mouseUpMoveScenario" @mousedown="mouseDownMoveScenario">
            <div class="scenario-view-background" :style="backgroundStyle">
                <div class="scenario-view" ref="scenarioRef" :style="scenarioStyle">
                    <NodeBox v-for="(node, index) in debugData" :index="index" :node="node" :key="node.id"></NodeBox>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { getBackgroundStyles, getInputEndpointUUID, getOutputEndpointUUID } from '@/utils/scenario-view.utils'
import { mapActions, mapState } from 'vuex'
import moveScenarioMixin from '../../mixins/move-scenario.mixin'
import { actionTypes } from '@/store/store.type'
import { ready } from '@jsplumb/browser-ui'
import NodeBox from '@/components/node/NodeBox.vue'
import { sync } from 'vuex-pathify'

export default {
    name: 'Scenario',
    mixins: [moveScenarioMixin],
    components: { NodeBox },
    mounted () {
        this.$store.commit(actionTypes.debug.INIT_INSTANCE, this.$refs.scenarioRef)
        ready(() => {
            this.$nextTick(async () => {
                await this.fetchDebugData()
                this.addConnections()
            })
        })
    },
    computed: {
        cardActive: sync('debug/cardActive'),
        ...mapState('debug', ['scenarioViewScale', 'instance', 'request_id', 'debugData']),
        backgroundStyle () {
            return getBackgroundStyles(this.scenarioViewScale, this.scenarioViewOffsetPosition, false)
        }
    },
    methods: {
        ...mapActions('ui', ['closeModal']),
        ...mapActions('debug', ['fetchDebugData', 'wheelScroll']),
        addConnections () {
            this.debugData.forEach((node, idx) => {
                const nextNode = this.debugData[idx + 1]
                if (nextNode) {
                    const inputUuid = getInputEndpointUUID(nextNode.id, idx + 1)
                    const outputUuid = getOutputEndpointUUID(node.id, idx)
                    this.instance.connect({
                        uuids: [outputUuid, inputUuid],
                        overlays: [
                            { type: 'Arrow', options: { width: 12, length: 7, location: 1, id: 'arrow' } }
                        ],
                        type: 'fci-normal'
                    })
                }
            })
        }
    },
    watch: {
        scenarioViewScale (newScale) {
            this.$refs.scenarioRef.style.transform = `scale(${newScale})`
        },
        async request_id () {
            const connections = this.instance.select()
            connections.entries.forEach(c => {
                this.instance.deleteConnection(c)
            })
            await this.fetchDebugData()
            this.addConnections()
            this.instance.repaintEverything()
            this.cardActive = null
        }
    }
}
</script>

<style lang="scss" scoped>
.scenario-view-root {
    position: relative;
    flex: 1;
    overflow: hidden;
    background-color: var(--color-canvas-background);
    width: 100%;
    height: 100%;
}

.scenario-view-wrapper {
    position: absolute;
}

.move-in-process {
    cursor: grabbing;
    cursor: -moz-grabbing;
    cursor: -webkit-grabbing;
    touch-action: none;
}

.move-active {
    cursor: grab;
    cursor: -moz-grab;
    cursor: -webkit-grab;
    touch-action: none;
}

.scenario-view-background {
    background-color: white;
    position: absolute;
    width: 10000px;
    height: 10000px;
    z-index: 1;
    background-repeat: repeat;
}

.scenario-view {
    position: relative;
    width: 100%;
    height: 100%;
    transform-origin: 0 0;
    z-index: 2;
    display: flex;
    flex-direction: column;
    gap: 60px;
}

.do-not-select *,
.jtk-drag-select * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}
</style>
